<div ngbDropdown placement="bottom" container="body" class="restaurant-selection" *ngIf="restaurants.length > 1">
    <h4 ngbDropdownToggle>{{currentRestaurant?.name}} <i class="mdi mdi-chevron-down"></i></h4>
    <div ngbDropdownMenu  class="dropdown-menu-end profile-dropdown">
        <ng-container  *ngFor="let restaurant of restaurants">
            <a *ngIf="!restaurant.as_shadow_with_main_id" class="notify-item" ngbDropdownItem (click)="changeRestaurant(restaurant.id)">
                <span style="cursor: pointer;">{{restaurant.name}}</span>
            </a>
        </ng-container>

    </div>
</div>
